module.exports = __webpack_public_path__ + "static/media/vzw-calc-logo-small.25e72496.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/vzw-calc-logo-small.svg
// module id = 1304
// module chunks = 0